'use strict';

/**
 * Component for the description
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');

var template = require('../../templates/components/field-colors.hbs');

var ColorComponent = LayoutView.extend({
    template: template,

    className: function() {
        var field = this.getOption('field');

        return 'form-component component-' + _.camelToHyphen(field.type);
    },

    colorsAvailable: [
        'black',
        'grey',
        'white',
        'blue',
        'cyan',
        'indigo',
        'purple',
        'magenta',
        'pink',
        'red',
        'orange',
        'yellow',
        'green',
        'olive',
        'brown',
        'gold',
        'copper',
        'silver',
        'colorless',
    ],

    ui: {
        'autosizeTextarea': 'textarea[data-autosize="true"]',
        'colorCheckboxes': '.color-listing-item input[type="checkbox"]',
    },

    events: {
        'input @ui.autosizeTextarea': 'fixTextareaSize',
    },

    viewData: {
        field: function() {
            return this.getOption('field');
        },

        availableColors: function() {
            return this.colorsAvailable;
        },

        customColors: function() {
            var customColors = '';

            var field = this.getOption('field');

            if (field.sourceFields && field.sourceFields.customColors) {
                customColors = this.model.get(field.sourceFields.customColors);
            }

            return customColors;
        },

        customColorsPlaceholder: function() {
            var placeholder = '';

            var field = this.getOption('field');
            var catalog = this.model.collection.catalog;

            if (field.sourceFields && field.sourceFields.customColors) {
                var customColorsField = catalog.getFieldDefinition(field.sourceFields.customColors);

                if (customColorsField && customColorsField.editview) {
                    placeholder = customColorsField.editview.placeholder;
                }
            }

            return placeholder;
        },
    },

    /**
     * Resets the states and data of the component
     */
    reset: function() {},

    onAttach: function() {
        this.fixTextareaSize(this.ui.autosizeTextarea);
    },

    onResize: function() {
        this.fixTextareaSize(this.ui.autosizeTextarea);
    },

    getData: function() {
        var data = {};
        var field = this.getOption('field');

        var colors = [];
        this.ui.colorCheckboxes.filter(':checked').each(function(index, checkbox) {
            colors.push($(checkbox).val());
        })

        data[field.name] = colors;

        if (field.sourceFields.customColors) {
            data[field.sourceFields.customColors] = this.$('[name="customColors"]').val().trim();
        }

        return data;
    },
});

module.exports = ColorComponent;